// extracted by mini-css-extract-plugin
export default {"shadowed":"Portfolio_shadowed__BYrH4","grid":"Portfolio_grid__f1C6m","wip":"Portfolio_wip__Hrrbj"};